import { DATA_TYPES } from "@constants/";
import { callAPI } from "@utils/Api";

export const updateUser = ({ id, data }) =>
  callAPI("data/update_attributes", "POST", {
    type: DATA_TYPES.BUYER,
    id,
    attributes: [data],
  });
